import { CountryCombination } from "../../../App/global/state-helpers/input";
import moment = require("moment");

const AllowedDobFormats = ['MM/DD/YYYY', 'M/D/YYYY', 'MM.DD.YYYY', 'M.D.YYYY', 'MM-DD-YYYY', 'M-D-YYYY'];
/* regularExpressionValidator - function takes value to run regexp against and type of expression with support for: text, tel, email and number */
export function regularExpressionValidator(value: string, type: string, countryCombination: CountryCombination = null, isPostalCode: boolean = false, isDOB: boolean = false) {
    var regExp = new RegExp(/\w/);

    switch (type) {
        case 'text':
            if (isPostalCode && countryCombination === CountryCombination.US) {
                regExp = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);
            }
            else if (isPostalCode && countryCombination === CountryCombination.Canada) {
                regExp = new RegExp(/^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}\s{1}\d{1}[A-Z]{1}\d{1}$/);
            }
            else if (isDOB) {
                let tryDate = moment(value, AllowedDobFormats, true);
                return tryDate.isValid() && tryDate.isBefore(moment());              
            }
            else {
                regExp = new RegExp(/\w/);
            }
            break;
        case 'tel':
            let length = value.replace(/\D/g, '').length;
            if (countryCombination === CountryCombination.USOrCanada) {
                return length === 10;
            }
            return length >= 4 && length <= 15;
        case 'email':
            regExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
            break;
        case 'textarea':
            regExp = new RegExp(/[^><]/);
            break;
        case 'url':
            regExp = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
            break;
    }

    return (regExp.test(value));
}

export function hasMatchingValues(firstValue: string, secondValue: string) {
    return firstValue === secondValue;
}
